import { gql } from '@apollo/client';

export const CREATE_MY_ORDER = gql`
    mutation CreateMyOrder(
        $cartId: String!
        $credits: Float
        $coupon: CouponInput
        $sessionId: String
        $isOci: Boolean
        $isElbridge: Boolean
    ) {
        createMyOrder(
            cartId: $cartId
            credits: $credits
            coupon: $coupon
            sessionId: $sessionId
            isOci: $isOci
            isElbridge: $isElbridge
        ) {
            id
            orderNumber
            custom {
                customFieldsRaw {
                    name
                    value
                }
            }
        }
    }
`;
